<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I dedicate this book to my husband Rob and sons, Heath and Ian, who have supported me throughout this venture. You are an amazing family rooted in faith, love, inclusion, empathy, grace, and silliness, and I am so blessed to be in this union with you.</p><br/>
<p style="text-indent: 0em;">I also want to give credit to my parents, Aubrey and Amy King, and my siblings Dorothy, Gloria, Herman, Sandra, Annette, Allison, Doreen, and sister-niece Tonya, all of whom helped groom my love of books, nature, culture, traditions, and the art of storytelling, especially when humor is involved.</p><br/>
<p style="text-indent: 0em;">For all those who fight against extremism, in all its polarizing, divisive, and judgmental forms, I applaud you. May love and inclusion; balance and equity replace alt-right and alt-left leanings so that we may live in peace and harmony with each other, the land, and its resources.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?a4d186f0